import Utils from 'common/src/code/utils';
import React from 'react';
import Fineprint from 'ui/Fineprint.component';
import InlineMessage from 'ui/panel/InlineMessage.component';

export const PendingPlanClosingDisclaimer = ({ accountInfo }) => {
	const formattedDate = Utils.Util.formatDateReadable(
		accountInfo.nextBillingDate
	);
	const ageOfAccount = Utils.Util.getAgeOfAccountInDays(
		accountInfo.customerDetails?.creationDate
	);
	const isPayGo = accountInfo.planDetails.planId === '381';
	const header = `You'll lose access to your account on ${formattedDate}`;
	let text = '';

	if (isPayGo) {
		text = `You'll stay logged in and have full access to your history, contacts, and prints until ${formattedDate}. You can reactivate your account anytime before then by selecting any plan below. After that date, your data will be permanently deleted.`;
	} else if (ageOfAccount <= 30) {
		text = `You'll stay logged in and have full access to your history, contacts, and prints until the last day of your risk-free trial on ${formattedDate}. You can reactivate your account anytime before then by selecting any plan below. After that date, your data will be permanently deleted.`;
	} else {
		text = `You'll stay logged in and have full access to your history, contacts, and prints until the last day of your billing cycle on ${formattedDate}. You can reactivate your account anytime before then by selecting any plan below. After that date, your data will be permanently deleted.`;
	}

	return (
		<InlineMessage
			className="pending-plan-closing-disclaimer"
			type="warning"
			dataqa="pending-plan-closing-disclaimer"
			header={header}
			text={text}
		/>
	);
};

export const PendingPlanClosingFineprint = ({ nextBillingDate }) => {
	const formattedDate = Utils.Util.formatDateReadable(nextBillingDate);
	return (
		<Fineprint
			type="warning"
			className="pending-plan-closing-fineprint"
			dataqa="pending-plan-closing-fineprint"
		>
			<b>You'll lose access to your account on {formattedDate}.</b> Reactivate
			your current plan or select a new plan in order to keep your account.
		</Fineprint>
	);
};
